var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 4",
    clipPath: "url(#clip0_1404_12356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.953 10.4388C23.9525 10.4383 23.9519 10.4377 23.9514 10.4372L14.1613 0.647461C13.744 0.22998 13.1892 0 12.599 0C12.0089 0 11.4541 0.229797 11.0366 0.647278L1.25161 10.4321C1.24832 10.4354 1.24502 10.4388 1.24172 10.4421C0.38479 11.304 0.386255 12.7024 1.24594 13.5621C1.6387 13.955 2.15743 14.1826 2.71206 14.2064C2.73458 14.2086 2.75729 14.2097 2.78018 14.2097H3.17037V21.4144C3.17037 22.84 4.33035 24 5.75637 24H9.58657C9.97476 24 10.2897 23.6852 10.2897 23.2969V17.6484C10.2897 16.9979 10.8189 16.4687 11.4694 16.4687H13.7286C14.3792 16.4687 14.9083 16.9979 14.9083 17.6484V23.2969C14.9083 23.6852 15.2231 24 15.6115 24H19.4417C20.8677 24 22.0277 22.84 22.0277 21.4144V14.2097H22.3895C22.9795 14.2097 23.5343 13.9799 23.9519 13.5624C24.8125 12.7013 24.8129 11.3005 23.953 10.4388Z",
    fill: "url(#paint0_linear_1404_12356)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_12356",
    x1: 12.5989,
    y1: -7.15256e-7,
    x2: 12.5989,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1404_12356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeActive);
export default __webpack_public_path__ + "static/media/icon_home_active.1e0a24132e823d3d1c38d845d77a46ec.svg";
export { ForwardRef as ReactComponent };